import _ from "lodash";
import { useNavigate } from "react-router-dom";

const toggleSideNav = () => {
    var sideNav = document.querySelector(".side-nav-custom");
    var toogleiconNav = document.querySelector("#openbtnNav .closetoogle");
    // console.log(btnClasslist)
    if (sideNav.classList.contains("opennav")) {
        toogleiconNav.classList.add("closeopen");
        sideNav.classList.remove("opennav");
    } else {
        sideNav.classList.add("opennav");
        toogleiconNav.classList.remove("closeopen");
    }
};
const VideoCatLeftMenu = (props) => {

    const { subCategories, categoryName,
        getSubCategoryVideos, setIsOwnCategoryClick,
        getCategoryVideos, isLoading
    } = props;
    const navigate = useNavigate();

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const catId = params.get('catId');
    const subCatId = params.get('subCatId');
    const providerId = params.get("providerId");

    return (
        <div className="side-navbar active-nav d-flexs flex-wrap flex-column">
            <div className="nav-box-sidebar d-flex gap-2">
                <div className={`nav-side-title cursor-pointer ${isLoading ? "not-allowed" : ""}`} onClick={() => {
                    navigate(providerId?`/video-listing?catId=${catId}&providerId=${providerId}`:`/video-listing?catId=${catId}`);
                    setIsOwnCategoryClick(true);
                    getCategoryVideos();
                }}>
                    {categoryName}
                </div>
                <button className="openbtn" id="openbtnNav"
                    // ref={hamburgerMenu}
                    onClick={() => {
                        toggleSideNav();
                    }}>
                    <span className="closetoogle"></span>
                </button>
            </div>
            <ul className="nav side-nav-custom opennav flex-column w-100">
                {!_.isEmpty(subCategories) && subCategories.map((item, index) => {
                    return <li className={subCatId !== null && parseInt(subCatId) === item?.sub_cat_id ? `nav-link active ${isLoading ? "not-allowed" : ""}` : `nav-link ${isLoading ? "not-allowed" : ""}`} onClick={() => {
                        getSubCategoryVideos(item?.sub_cat_id)
                        navigate(providerId ? `/video-listing?catId=${catId}&subCatId=${item.sub_cat_id}&providerId=${providerId}`:`/video-listing?catId=${catId}&subCatId=${item.sub_cat_id}`, {replace: true});
                    }}>
                        <span className="mx-2">{item?.sub_cat_name}</span>
                    </li>
                })}
            </ul>
        </div>
    )
}

export default VideoCatLeftMenu;